export const sortByDate = (a: string, b: string) => new Date(a).getTime() - new Date(b).getTime()

export const getTimeFromSeconds = (seconds: number) => {
    const date = new Date(0)
    date.setSeconds(seconds)
    return date.toISOString().substr(11, 8)
}